export default __webpack_public_path__ + "static/escolhi-amar-020a4b7fc9db30b6508e1749a2d25b10.png";